export default class AdminTreatmentAdvice {
    axiosIns = null
    jwtConfig = null
  
    constructor(axiosIns, jwtConfig) {
      this.axiosIns = axiosIns;
      this.jwtConfig = jwtConfig;
    }
  
    downloadReportPDF(id) {
      return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}/${id}/download-treatment-advice-report`)
    }
}
